import type { IAddress } from "@/types/address";
import type { IServiceArea } from "@/types/common";
import type { IUser } from "@/types/users";
import { UserRole } from "@/types/users";

export type IInspector = IUser & {
  userId: number;
  role: UserRole.Inspector;
  address: IAddress;
  isHudApproved: boolean;
  license?: IInspectorLicense;
  hudDetail?: IInspectorHud;
  w9Form?: IInspectorW9Form;
  yearsOfExperience: number;
  serviceAreas: IServiceArea[];
};

export enum W9EntityType {
  Individual = "Individual",
  Corporate = "Corporate",
  LLC = "LLC",
}

export type IInspectorLicense = {
  userId: number;
  documentNumber: string;
  issuanceDate: string;
  expiryDate: string;
  frontImageUrl?: string;
  backImageUrl?: string;
  createdOn: string;
  updatedOn: string;
};

export type IInspectorHud = {
  userId: number;
  documentNumber: string;
  issuanceDate: string;
  expiryDate: string;
  frontImageUrl?: string;
  backImageUrl?: string;
  createdOn: string;
  updatedOn: string;
};

export type IInspectorW9Form = {
  userId: number;
  name: string;
  tin: string;
  ssn: string;
  entityType: string;
  frontImageUrl: string;
  submittedDate: string;
  verified: boolean;
};

export const isInspector = (user: IUser): user is IInspector => {
  return user.role === UserRole.Inspector;
};
